"use strict";

var React = require('react');
var Immutable = require('immutable');

class ProgramGroupNavigation extends React.Component {
	render() {
		var { model, ...other } = this.props;

		if (!model || model.isEmpty()) {
			return false;
		}
		return (
			<nav {...other} className="svtse_program-list-nav" id="navigation_a-o">
				{model.map(function (group, key) {
					if (group.isEmpty()) {
						return (
							<span key={key} className="svtse_program-list-nav__link  svtse_program-list-nav__link--inactive">{key}</span>
						);
					} else {
						return (
							<a href={'#' + key} key={key} className="svtse_program-list-nav__link">{key}</a>
						);
					}
				})}
			</nav>
		);
	}
}

ProgramGroupNavigation.propTypes = {
	model: React.PropTypes.instanceOf(Immutable.OrderedMap).isRequired
};

module.exports = ProgramGroupNavigation;



/** WEBPACK FOOTER **
 ** ./app/components/ProgramListHandler/ProgramGroupNavigation.jsx
 **/